import { Link } from 'react-router-dom';

const articles = [
  {
    slug: '/artikel/oopbuy-spreadsheet-guide',
    date: '15. Juli 2026',
    readingTime: '12 Min.',
    title: 'OOPBuy Spreadsheet Guide 2026: Der komplette Leitfaden',
    desc: 'Alles was Du über das OOPBuy Spreadsheet wissen musst – von der Einrichtung bis zu Profi-Tipps.',
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%20on%20screen%2C%20warm%20natural%20lighting%20streaming%20through%20window%2C%20minimalist%20desk%20setup%20with%20notebook%20and%20coffee%20cup%2C%20cream%20and%20beige%20interior%20with%20wooden%20accents%2C%20editorial%20photography%20style%2C%20clean%20professional%20composition&width=600&height=400&seq=article-guide-main-y01&orientation=landscape",
  },
  {
    slug: '/artikel/oopbuy-qc-guide',
    date: '15. Juli 2026',
    readingTime: '10 Min.',
    title: 'OOPBuy QC Guide: Qualitätskontrolle einfach erklärt',
    desc: 'Alles zur OOPBuy QC – so prüfst Du Produkte vor dem Kauf mit Checkliste und Praxisbeispielen.',
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20quality%20inspection%20scene%20with%20magnifying%20glass%20over%20product%20on%20clean%20desk%2C%20checklist%20clipboard%20nearby%2C%20soft%20daylight%20from%20window%2C%20modern%20minimal%20office%2C%20warm%20neutral%20tones%2C%20crisp%20focus%20editorial%20photography&width=600&height=400&seq=article-qc-y02&orientation=landscape",
  },
  {
    slug: '/artikel/oopbuy-versand-guide',
    date: '14. Juli 2026',
    readingTime: '9 Min.',
    title: 'OOPBuy Versand Guide: Lieferung nach Deutschland',
    desc: 'Alles zu OOPBuy Versand und Lieferzeiten – so kommen Deine Bestellungen sicher nach Deutschland.',
    imageUrl: "https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20with%20packing%20tape%20and%20shipping%20labels%20on%20clean%20white%20desk%2C%20world%20map%20on%20wall%20behind%2C%20warm%20natural%20light%2C%20modern%20logistics%20workspace%20aesthetic%2C%20parcels%20ready%20for%20international%20delivery&width=600&height=400&seq=article-versand-y03&orientation=landscape",
  },
  {
    slug: '/artikel/oopbuy-verkaeufer-guide',
    date: '13. Juli 2026',
    readingTime: '10 Min.',
    title: 'OOPBuy Verkäufer Guide: Die besten Seller finden',
    desc: 'Vertrauenswürdige OOPBuy Seller identifizieren – mit Bewertungen, Erfahrungen und Tipps.',
    imageUrl: "https://readdy.ai/api/search-image?query=Business%20professional%20reviewing%20seller%20profiles%20on%20tablet%20device%20at%20modern%20desk%2C%20warm%20office%20lighting%2C%20clean%20aesthetic%20with%20notebook%20and%20coffee%2C%20confident%20atmosphere%2C%20soft%20cream%20and%20warm%20wood%20tones&width=600&height=400&seq=article-seller-y04&orientation=landscape",
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-schuhe',
    date: '12. Juli 2026',
    readingTime: '7 Min.',
    title: 'OOPBuy Spreadsheet Schuhe: Beste Sneaker & mehr',
    desc: 'Entdecke die Top-Schuhe im Spreadsheet – von Sneakern bis Luxus mit QC-Tipps.',
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20sneaker%20collection%20on%20tiered%20wooden%20shelf%20against%20cream%20wall%2C%20natural%20side%20lighting%2C%20diverse%20casual%20to%20sporty%20styles%2C%20curated%20shoe%20store%20aesthetic%2C%20editorial%20footwear%20photography%2C%20warm%20neutral%20tones&width=600&height=400&seq=article-schuhe-y05&orientation=landscape",
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-hoodie',
    date: '11. Juli 2026',
    readingTime: '6 Min.',
    title: 'OOPBuy Spreadsheet Hoodie: Beste Pullover & Sweater',
    desc: 'Die Top-Hoodies im Spreadsheet – von Oversized bis Premium mit Material-Guide.',
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20hoodies%20in%20earthy%20tones%20on%20minimalist%20clothing%20rack%2C%20warm%20studio%20lighting%2C%20soft%20fabric%20textures%20visible%2C%20modern%20streetwear%20aesthetic%2C%20cream%20wall%20background%2C%20editorial%20fashion%20photography&width=600&height=400&seq=article-hoodie-y06&orientation=landscape",
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-jacken',
    date: '10. Juli 2026',
    readingTime: '6 Min.',
    title: 'OOPBuy Spreadsheet Jacken: Beste Jacken & Mäntel',
    desc: 'Top-Jacken im Spreadsheet – von Bomberjacken über Wintermäntel bis Designer-inspiriert.',
    imageUrl: "https://readdy.ai/api/search-image?query=Variety%20of%20premium%20jackets%20on%20wooden%20hangers%20against%20textured%20concrete%20wall%2C%20autumn%20fashion%20aesthetic%2C%20leather%20bomber%20and%20wool%20coat%20displayed%2C%20warm%20amber%20and%20charcoal%20tones%2C%20editorial%20fashion%20photography&width=600&height=400&seq=article-jacken-y07&orientation=landscape",
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-taschen',
    date: '9. Juli 2026',
    readingTime: '5 Min.',
    title: 'OOPBuy Spreadsheet Taschen: Totes & Rucksäcke',
    desc: 'Die besten Taschen im Spreadsheet – Leder, Canvas und Designer-inspiriert.',
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20handbags%20and%20totes%20in%20neutral%20tones%20on%20marble%20surface%20with%20soft%20window%20light%2C%20leather%20and%20canvas%20textures%2C%20luxury%20accessories%20photography%2C%20warm%20beige%20palette%2C%20minimalist%20editorial%20composition&width=600&height=400&seq=article-taschen-y08&orientation=landscape",
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-accessoires',
    date: '8. Juli 2026',
    readingTime: '5 Min.',
    title: 'OOPBuy Spreadsheet Accessoires: Schmuck & Uhren',
    desc: 'Entdecke die besten Accessoires – von Edelstahl-Schmuck bis Designer-Uhren.',
    imageUrl: "https://readdy.ai/api/search-image?query=Curated%20flat%20lay%20of%20minimalist%20accessories%20including%20gold%20watch%2C%20leather%20bracelet%20and%20sunglasses%20on%20textured%20linen%2C%20morning%20light%2C%20metallic%20accents%2C%20clean%20modern%20aesthetic%2C%20cream%20and%20gold%20tones&width=600&height=400&seq=article-accessoires-y09&orientation=landscape",
  },
  {
    slug: '/artikel/oopbuy-spreadsheet-sets',
    date: '7. Juli 2026',
    readingTime: '5 Min.',
    title: 'OOPBuy Spreadsheet Sets: Beste Outfit-Kombis',
    desc: 'Komplette Outfits zu unschlagbaren Preisen – von Sport-Sets bis Casual-Looks.',
    imageUrl: "https://readdy.ai/api/search-image?query=Coordinated%20fashion%20outfit%20sets%20on%20minimalist%20rack%2C%20matching%20hoodie%20and%20sweatpants%20in%20sage%20green%2C%20soft%20natural%20window%20light%2C%20modern%20streetwear%20aesthetic%2C%20clean%20beige%20wall%2C%20lifestyle%20photography&width=600&height=400&seq=article-sets-y10&orientation=landscape",
  },
];

export default function ArticlePreview() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <p className="text-foreground-500 text-xs md:text-sm font-medium tracking-wider uppercase mb-2">
              Neueste Guides
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              OOPBuy Spreadsheet Artikel
            </h2>
          </div>
          <Link
            to="/artikel/oopbuy-spreadsheet-guide"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            Alle Artikel ansehen
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article, idx) => (
            <Link
              key={idx}
              to={article.slug}
              className="group bg-white rounded-2xl overflow-hidden hover:scale-[1.02] transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.readingTime}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed mb-3 line-clamp-2 flex-1">
                  {article.desc}
                </p>
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600 whitespace-nowrap">
                  Weiterlesen
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}